import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Operation Approvals list
@return { Array }
*/
export const getOperationApprovalsList = state => state.operationApprovalsList

/** returns approvals hasMore value
@return { Boolean }
*/
export const getApprovalsHasMore = state => state.approvalsHasMore

/** returns accounts with operations pending signature
@return { Array }
*/
export const getAccountsWithOperationsPendingSignature = state => state.accountsWithOperationsPendingSignature

/** returns total number of operations to sign
@return { Number }
*/
export const getTotalNumberOfOperationsToSign = state => {
    return state.totalNumberOfOperationsToSign
}
